module.exports = "/images/circle-marker-gray.png?007c09b9adb58403faffaf7df5cc2e46";